import _dateFormat from './dateFormat';
export const dateFormat = _dateFormat
/**
 * Throttle
 * @param fn {func}
 * @param delay {number}
 */

export const Throttle = (fn, delay = 500) => {
  const self = fn
  const isFirst = false
  let timer = null

  return (...rest) => {
    if (!isFirst) {
      self(...rest)
    }

    if (timer) {
      return
    }

    timer = setTimeout(() => {
      clearTimeout(timer)
      timer = null
      self(...rest)
    }, delay)
  }
}

/**
 * 防抖函数
 * @param method 事件触发的操作
 * @param delay 多少毫秒内连续触发事件，不会执行
 * @returns {Function}
 */
export const debounce = (method, delay = 50) => {
  let timer = null
  return (...rest) => {
    timer && clearTimeout(timer)
    timer = setTimeout(() => {
      method(...rest)
    }, delay)
  }
}

export const getDateRange = () => {
  let dateRange = [];
  const startTime1 = new Date();
  const startTime3 = new Date();
  const startTime7 = new Date();
  const startTime30 = new Date();
  const endTime = new Date();
  // 今天
  dateRange.push({
    label: "今天",
    type: "1",
    addTime: startTime1.setTime(
      startTime1.getTime() -
        (startTime1.getHours() * 3600 +
          startTime1.getMinutes() * 60 +
          startTime1.getSeconds()) *
          1000
    ),
    endTime: endTime.getTime()
  });
  // 最近三天
  dateRange.push({
    label: "最近三天",
    type: "2",
    addTime: startTime3.setTime(
      startTime3.getTime() - 3600 * 1000 * 24 * 3
    ),
    endTime: endTime.getTime()
  });
  // 最近一周
  dateRange.push({
    label: "最近一周",
    type: "3",
    addTime: startTime7.setTime(
      startTime7.getTime() - 3600 * 1000 * 24 * 7
    ),
    endTime: endTime.getTime()
  });
  // 最近一个月
  dateRange.push({
    label: "最近一个月",
    type: "4",
    addTime: startTime30.setTime(
      startTime30.getTime() - 3600 * 1000 * 24 * 30
    ),
    endTime: endTime.getTime()
  });
  return dateRange
}
